export default "__VITE_ASSET__zXeUlATZ__"